import {
  TaskStatusName,
  useTaskTableQuery
} from 'generated/graphql';
import { DateTime } from 'luxon';
import React from 'react';

export interface IData {
  id: string;
  title: string;
  readableId: string;
  dueDate: DateTime | null;
  createdDate: DateTime;
  category: string;
  assignee: string;
  statusName: TaskStatusName;
}

export function useQuery(projectId: string) {
  const tuple = useTaskTableQuery({
    variables: {
      id: projectId
    },
    skip: projectId === ''
  });

  return React.useMemo(
    () => {
      const data: IData[] = tuple.data?.project?.tasks.map((node) => ({
        id: node?.id ?? '',
        title: node?.name ?? '',
        readableId: node?.taskNumber ?? '',
        dueDate: node?.dueDate ?? null,
        createdDate: node?.createdAt ?? DateTime.now(),
        category: node?.category?.displayName ?? '',
        assignee: node?.assignee?.fullName ?? '',
        statusName: node?.status.name ?? 'open'
      })) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
